import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex flex-wrap" }

import DefaultButton from '@/components/Buttons/DefaultButton.vue';
import { PropType } from 'vue';
import TextFilterChip from './TextFilterChip.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  filters: Object as PropType<Set<string>>,
},
  emits: ['remove', 'removeAll'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.filters && __props.filters.size > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (filter, idx) => {
                return (_openBlock(), _createBlock(TextFilterChip, {
                  key: idx,
                  text: filter,
                  onRemove: ($event: any) => (_ctx.$emit('remove', filter))
                }, null, 8, ["text", "onRemove"]))
              }), 128))
            ]),
            _createVNode(DefaultButton, {
              class: "mb-1 flex-shrink-0",
              text: "Clear all",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('removeAll')))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})